import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';

import AutomatedReportsTable from './AutomatedReportsTable';

storiesOf('Manage Alerts/AutomatedReports/AutomatedReportsTable', module)
  .add('Loading', () => (
    <AutomatedReportsTable
      alerts={[]}
      isLoading
    />
  ))
  .add('View without data', () => (
    <AutomatedReportsTable
      alerts={[]}
      isLoading={false}
    />
  ))
  .add('View', () => (
    <AutomatedReportsTable
      alerts={sampleGetAlertsResponse.alerts}
      isLoading={false}
      onRemoveButtonClick={action('onRemoveButtonClick')}
    />
  ));

const sampleGetAlertsResponse = {
  alerts: [
    {
      isBeingRemoved: true,
      rtalert_cron_id: '1145',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'casbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: `casbke_431519,casbke_431520,casbke_431528,casbke_431552,casbke_431555,casbke_431556,
        casbke_431562,casbke_431582,casbke_431581,casbke_431589,casbke_431592,casbke_431595,casbke_431594,casbke_431596,
        casbke_431599,casbke_431622,casbke_431634`,
      created: '1532043435',
      modified: '2018-10-21 12:00:29',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'filed',
        chapter: [
          '11',
          '7',
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: '',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: 1,
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: 1,
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1146',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'mdbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: 'mdbke_721685,mdbke_721772,mdbke_721873,mdbke_721885,mdbke_721886,mdbke_721908',
      created: '1532043549',
      modified: '2018-10-21 12:00:32',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'filed',
        chapter: [
          '11',
          '7',
          '12',
          '9',
          '15',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: 'b',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: 1,
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: '',
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1147',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'cacbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: `cacbke_1842157,cacbke_1842164,cacbke_1842167,cacbke_1842172,cacbke_1842182,cacbke_1842185,
        cacbke_1842192,cacbke_1842197,cacbke_1842199,cacbke_1842200,cacbke_1842201,cacbke_1842215,cacbke_1842227,
        cacbke_1842235,cacbke_1842245,cacbke_1842247,cacbke_1842248,cacbke_1842252,cacbke_1842257,cacbke_1842268,
        cacbke_1842282,cacbke_1842283,cacbke_1842293,cacbke_1842348,cacbke_1842158,cacbke_1842160,cacbke_1842165,
        cacbke_1842174,cacbke_1842177,cacbke_1842180,cacbke_1842188,cacbke_1842190,cacbke_1842193,cacbke_1842195,
        cacbke_1842202,cacbke_1842210,cacbke_1842214,cacbke_1842239,cacbke_1842267,cacbke_1842209,cacbke_1842217,
        cacbke_1842343,cacbke_1842344,cacbke_1842365,cacbke_1842372,cacbke_1842373,cacbke_1842377,cacbke_1842384,
        cacbke_1842404,cacbke_1842410,cacbke_1842341,cacbke_1842342,cacbke_1842349,cacbke_1842351,cacbke_1842375,
        cacbke_1842389,cacbke_1842350,cacbke_1842396,cacbke_1842346,cacbke_1842353,cacbke_1842525,cacbke_1842537,
        cacbke_1842443,cacbke_1842446,cacbke_1842447,cacbke_1842449,cacbke_1842452,cacbke_1842454,cacbke_1842483,
        cacbke_1842487,cacbke_1842520,cacbke_1842522,cacbke_1842526,cacbke_1842445,cacbke_1842448,cacbke_1842491,
        cacbke_1842495,cacbke_1842538,cacbke_1842533,cacbke_1842516,cacbke_1842596,cacbke_1842603,cacbke_1842611,
        cacbke_1842618,cacbke_1842622,cacbke_1842623,cacbke_1842638,cacbke_1842642,cacbke_1842660,cacbke_1842667,
        cacbke_1842669,cacbke_1842670,cacbke_1842683,cacbke_1842598,cacbke_1842607,cacbke_1842615,cacbke_1842625,
        cacbke_1842637,cacbke_1842671,cacbke_1842658,cacbke_1842663,cacbke_1842751,cacbke_1842814,cacbke_1842731,
        cacbke_1842773,cacbke_1842795,cacbke_1842800,cacbke_1842802,cacbke_1842813,cacbke_1842818,cacbke_1842820,
        cacbke_1842822,cacbke_1842829,cacbke_1842742,cacbke_1842752,cacbke_1842756,cacbke_1842772,cacbke_1842774,
        cacbke_1842789,cacbke_1842794,cacbke_1842816,cacbke_1842821,cacbke_1842732,cacbke_1842744`,
      created: '1532043644',
      modified: '2018-10-21 12:00:46',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'filed',
        chapter: [
          '11',
          '7',
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: '',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: 1,
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: 1,
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1149',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'scbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: `scbke_252228,scbke_252953,scbke_255637,scbke_256433,scbke_256478,scbke_256719,scbke_258242,
        scbke_258925,scbke_259297,scbke_259609,scbke_259705,scbke_260269,scbke_260776,scbke_264576,scbke_266108,
        scbke_266249,scbke_266315,scbke_267603,scbke_268345,scbke_270367,scbke_270594,scbke_270697,scbke_271384,
        scbke_271658,scbke_273796,scbke_274079,scbke_274348,scbke_275704,scbke_276121,scbke_276527,scbke_276888,
        scbke_277244,scbke_277519,scbke_278110,scbke_278616,scbke_279924,scbke_281360,scbke_281519,scbke_281600,
        scbke_282650,scbke_282670,scbke_282804,scbke_282863,scbke_283038,scbke_283378,scbke_283404,scbke_283436,
        scbke_283455,scbke_283760,scbke_283846,scbke_283867,scbke_283922,scbke_284274,scbke_284298,scbke_284394,
        scbke_284441,scbke_284448,scbke_284473,scbke_284637,scbke_284642,scbke_284664,scbke_284674,scbke_284968,
        scbke_284999,scbke_285022,scbke_285027,scbke_285035,scbke_285119`,
      created: '1532043825',
      modified: '2018-10-21 12:00:57',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'dismissed',
        chapter: [
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: '',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: '',
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: '',
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1150',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'txwbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: `txwbke_293200,txwbke_294902,txwbke_299194,txwbke_302258,txwbke_305876,txwbke_306584,
        txwbke_310280,txwbke_310888,txwbke_312029,txwbke_312534,txwbke_317889,txwbke_318591,txwbke_318744,txwbke_321130,
        txwbke_322892,txwbke_324012,txwbke_324313,txwbke_324317,txwbke_324813,txwbke_324978,txwbke_325186,txwbke_326219,
        txwbke_326607,txwbke_328686,txwbke_329119,txwbke_329407,txwbke_329428,txwbke_329857,txwbke_330169,txwbke_330091,
        txwbke_330366,txwbke_330404,txwbke_330452,txwbke_330833,txwbke_330812,txwbke_331285,txwbke_331269,txwbke_331407,
        txwbke_331385,txwbke_331477,txwbke_309768,txwbke_331512`,
      created: '1532043926',
      modified: '2018-10-21 12:01:05',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'dismissed',
        chapter: [
          '7',
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: 'c',
        type_of_debtor: 'i',
        nature_of_business: '',
        open_cases: '',
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: '',
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1151',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1532260800',
      time_end: '1847919600',
      interval_minute: '10080',
      court_code: 'utbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123800',
      discovered_cases: `utbke_425393,utbke_425396,utbke_425413,utbke_425437,utbke_425474,utbke_425500,utbke_425504,
        utbke_425513,utbke_425523,utbke_425558,utbke_425564`,
      created: '1532044022',
      modified: '2018-10-21 12:10:05',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'filed',
        chapter: [
          '7',
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: '',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: '',
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: 1,
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
    {
      rtalert_cron_id: '1152',
      uid_creator: '1',
      uid_master: '1',
      time_start: '1534680000',
      time_end: '1850335200',
      interval_minute: '10080',
      court_code: 'flmbke',
      chapter_code: '0',
      case_type: '',
      csv: '0',
      enabled: '1',
      time_last_run: '1540123200',
      discovered_cases: `flmbke_1111834,flmbke_1130470,flmbke_1185372,flmbke_1202730,flmbke_1202917,flmbke_1208913,
        flmbke_1213082,flmbke_1212984,flmbke_1225885,flmbke_1229203,flmbke_1229801,flmbke_1230981,flmbke_1237066,
        flmbke_1241530,flmbke_1243317,flmbke_1245309,flmbke_1246291,flmbke_1246481,flmbke_1249462,flmbke_1249641,
        flmbke_1251240,flmbke_1253818,flmbke_1254799,flmbke_1255070,flmbke_1255195,flmbke_1255777,flmbke_1256939,
        flmbke_1257182,flmbke_1257724,flmbke_1257868,flmbke_1258299,flmbke_1258855,flmbke_1259027,flmbke_1260099,
        flmbke_1260108,flmbke_1260318,flmbke_1260610,flmbke_1260910,flmbke_1261167,flmbke_1264614,flmbke_1264843,
        flmbke_1265800,flmbke_1265929,flmbke_1266205,flmbke_1266093,flmbke_1266099,flmbke_1266450,flmbke_1266537,
        flmbke_1266639,flmbke_1266682,flmbke_1266662,flmbke_1266731,flmbke_1266880,flmbke_1266697,flmbke_1266795,
        flmbke_1266883,flmbke_1266800,flmbke_1266846,flmbke_1266915,flmbke_1267064,flmbke_1266949,flmbke_1267056,
        flmbke_1267085,flmbke_1267292,flmbke_1267148,flmbke_1267044,flmbke_1267127,flmbke_1267142,flmbke_1267415,
        flmbke_1267329`,
      created: '1534370964',
      modified: '2018-10-21 12:01:20',
      disabled: '0',
      search_params: {
        query_type: 'localcourtreport',
        date_type: 'dismissed',
        chapter: [
          '13',
        ],
        case_type: 'bk',
        asset_notice: '',
        nature_of_debt: '',
        type_of_debtor: '',
        nature_of_business: '',
        open_cases: '',
        closed_cases: '',
        voluntary: '',
        involuntary: '',
        smallbusiness: '',
        proseonly: '',
        nature_of_suit: '',
        citation: '',
        office: '',
        cause: '',
        jurisdic: '',
        case_flags: '',
        cvbcases: '',
        pending_defendants: '',
        terminated_defendants: '',
        pacer_client_code: '',
      },
      creator_name:
        `<a href="https://www.inforuptcy.com/users/inforuptcy-team-profile" title="View user profile.">
            Inforuptcy Team
        </a>`,
      interval_str: '1 week',
    },
  ],
  input: {
    filter: [],
    validate: [],
  },
};



// WEBPACK FOOTER //
// ./src/components/searchAlerts/AutomatedReports/AutomtatedReportsTable.stories.jsx